"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawerInjectionKey = exports.drawerBodyInjectionKey = void 0;
const create_injection_key_1 = require("../../_utils/vue/create-injection-key");
exports.drawerBodyInjectionKey = (0, create_injection_key_1.createInjectionKey)('n-drawer-body');
exports.drawerInjectionKey = (0, create_injection_key_1.createInjectionKey)('n-drawer');
